export default __webpack_public_path__ + "static/media/11.472785b1.jpg";